import { createAction } from 'redux-actions';

export const IS_DISTRIBUTE_TO_SCHOOL = 'IS_DISTRIBUTE_TO_SCHOOL';

export default function isDistributeToSchool(state = null, { payload, type }) {
  switch (type) {
    case IS_DISTRIBUTE_TO_SCHOOL: {
      return payload;
    }
    default:
      return state;
  }
}

export const setIsDistributeToSchool = (isDTS) => {
  return (dispatch) => {
    const action = createAction(IS_DISTRIBUTE_TO_SCHOOL)(isDTS);
    dispatch(action);
  };
};
